export var FOCUS_KEY = {
    GNB: function (gnbMenuType) { return "GNB_".concat(gnbMenuType); },
    BOARD: function () { return 'BOARD'; },
    LIST: function () { return 'LIST'; },
    QR: function () { return 'QR'; },
    QR_BUTTON: function () { return 'QR_BUTTON'; },
    PINCODE_BUTTON: function () { return 'PINCODE_BUTTON'; },
    ONBOARDING: function () { return 'ONBOARDING'; },
    ONBOARDING_BUTTON: function (buttonIndex) { return "ONBOARDING_BUTTON_".concat(buttonIndex); },
    LOGIN: function () { return 'LOGIN'; },
    LOGIN_BUTTON: function (buttonIndex) { return "LOGIN_BUTTON_".concat(buttonIndex); },
    TVLOGIN: function () { return 'LOGIN'; },
    TVLOGIN_BUTTON: function (buttonIndex) { return "TVLOGIN_BUTTON_".concat(buttonIndex); },
    TVLOGIN_CHECKBOX: function () { return "TVLOGIN_CHECKBOX"; },
    WELCOME: function () { return 'WELCOME'; },
    WELCOME_BUTTON: function (buttonIndex) { return "WELCOME_BUTTON_".concat(buttonIndex); },
    DETAIL: function () { return 'DETAIL'; },
    DETAIL_MENU: function (detailMenuItemType) { return "DETAIL_MENU_".concat(detailMenuItemType); },
    DETAIL_2DEPTH_MENU: function () { return 'DETAIL_2DEPTH_MENU'; },
    DETAIL_MENU_ITEM: function (menuItemIndex) { return "DETAIL_MENU_ITEM_".concat(menuItemIndex); },
    DETAIL_2DEPTH_MENU_ITEM: function (mediaCode) { return "DETAIL_2DEPTH_MENU_ITEM_".concat(mediaCode); },
    DETAIL_LIST: function () { return 'DETAIL_LIST'; },
    PROFILE_LIST: function () { return 'PROFILE_LIST'; },
    PROFILE_LIST_ITEM: function (index) { return "PROFILE_LIST_ITEM_".concat(index); },
    PROFILE_LIST_LOGOUT: function () { return 'PROFILE_LIST_LOGOUT'; },
    PROFILE_EDIT_PROFILE_IMAGE: function () { return 'PROFILE_EDIT_PROFILE_IMAGE'; },
    PROFILE_EDIT_PASSWORD_CHECKBOX: function () { return 'PROFILE_EDIT_PASSWORD_CHECKBOX'; },
    PROFILE_EDIT_CONFIRM_BUTTON: function () { return 'PROFILE_EDIT_CONFIRM_BUTTON'; },
    PROFILE_EDIT_CANCEL_BUTTON: function () { return 'PROFILE_EDIT_CANCEL_BUTTON'; },
    PROFILE_EDIT_DELETE_BUTTON: function () { return 'PROFILE_EDIT_DELETE_BUTTON'; },
    PROFILE_EDIT_TEXT_INPUT: function () { return 'PROFILE_EDIT_TEXT_INPUT'; },
    PROFILE_IMAGE_LIST: function () { return 'PROFILE_IMAGE_LIST'; },
    PROFILE_PASSWORD: function () { return 'PROFILE_PASSWORD'; },
    PROFILE_PASSWORD_KEY: function (passwordCharacter) { return "PROFILE_PASSWORD_KEY_".concat(passwordCharacter); },
    PROFILE_PASSWORD_DELETE_KEY: function () { return 'PROFILE_PASSWORD_DELETE_KEY'; },
    PROFILE_PASSWORD_CONFIRM_BUTTON: function () { return 'PROFILE_PASSWORD_CONFIRM_BUTTON'; },
    PROFILE_PASSWORD_RETURN_BUTTON: function () { return 'PROFILE_PASSWORD_RETURN_BUTTON'; },
    PROFILE_PASSWORD_INITIALIZE_BUTTON: function () { return 'PROFILE_PASSWORD_INITIALIZE_BUTTON'; },
    PROFILE_PASSWORD_RESET: function () { return 'PROFILE_PASSWORD_RESET'; },
    PROFILE_PASSWORD_RESET_TEXT_INPUT: function () { return 'PROFILE_PASSWORD_RESET_TEXT_INPUT'; },
    PROFILE_PASSWORD_RESET_CONFIRM_BUTTON: function () { return 'PROFILE_PASSWORD_RESET_CONFIRM_BUTTON'; },
    BILLING_MAIN: function () { return 'BILLING_MAIN'; },
    BILLING_CARD: function (cardIndex) { return "BILLING_CARD_".concat(cardIndex); },
    BILLING_CARD_BUTTON: function (cardIndex, buttonIndex) { return "BILLING_CARD_BUTTON_".concat(cardIndex, "_").concat(buttonIndex); },
    BILLING_CAUTION_BUTTON: function () { return 'BILLING_CAUTION_BUTTON'; },
    BILLING_AFFILIATE_NAVER_BUTTON: function () { return 'BILLING_AFFILIATE_NAVER_BUTTON'; },
    BILLING_AFFILIATE_KT_BUTTON: function () { return 'BILLING_AFFILIATE_KT_BUTTON'; },
    BILLING_AFFILIATE_LG_BUTTON: function () { return 'BILLING_AFFILIATE_LG_BUTTON'; },
    SMS: function () { return 'SMS'; },
    SMS_PHONE_NUMBER_KEY: function (phoneNumberCharacter) { return "SMS_PHONE_NUMBER_KEY_".concat(phoneNumberCharacter); },
    SMS_PHONE_DELETE_KEY: function () { return 'SMS_PHONE_DELETE_KEY'; },
    SMS_SEND_BUTTON: function () { return 'SMS_SEND_BUTTON'; },
    CERTIFICATION_CONFIRM_BUTTON: function () { return 'CERTIFICATION_CONFIRM_BUTTON'; },
    PLAYER: function () { return 'PLAYER'; },
    PLAYER_CONTROL: function (controlId) { return "PLAYER_CONTROL_".concat(controlId); },
    PLAYER_CONTROL_BUTTON: function (buttonId) { return "PLAYER_CONTROL_BUTTON_".concat(buttonId); },
    PLAYER_THUMBNAIL: function () { return 'PLAYER_THUMBNAIL'; },
    PLAYER_SUBTITLE: function () { return 'PLAYER_SUBTITLE'; },
    PLAYER_SUBTITLE_SETTING_BUTTON: function () { return 'PLAYER_SUBTITLE_SETTING_BUTTON'; },
    PLAYER_SUBTITLE_BUTTON: function (buttonId) { return "PLAYER_SUBTITLE_".concat(buttonId); },
    PLAYER_OVER_TOP_BUTTON: function () { return 'PLAYER_OVER_TOP_BUTTON'; },
    PLAYER_TIMESTAMP: function () { return 'PLAYER_TIMESTAMP'; },
    // 동접 차단
    PLAYER_BLOCK: function () { return 'PLAYER_BLOCK'; },
    PLAYER_BLOCK_BUTTON: function (buttonIndex) { return "PLAYER_BLOCK_BUTTON_".concat(buttonIndex); },
    // 검색
    SEARCH: function () { return 'SEARCH'; },
    SEARCH_RESULT: function () { return 'SEARCH_RESULT'; },
    SEARCH_RESULT_LIST: function () { return 'SEARCH_RESULT_LIST'; },
    SEARCH_RECOMMEND: function () { return 'SEARCH_RECOMMEND'; },
    SEARCH_INPUT_BOX: function () { return 'SEARCH_INPUT_BOX'; },
    SEARCH_INPUT_BUTTON: function () { return 'SEARCH_INPUT_BUTTON'; },
    TVING_VIRTUAL_KEYBOARD: function () { return 'TVING_VIRTUAL_KEYBOARD'; },
    // 설정
    SETTING: function () { return 'SETTING'; },
    SETTING_MENU: function () { return 'SETTING_MENU'; },
    SETTING_MENU_BUTTON: function (buttonId) { return "SETTING_MENU_BUTTON_".concat(buttonId); },
    SETTING_CONTENT: function () { return "SETTING_CONTENT"; },
    SETTING_REGISTER: function () { return "SETTING_REGISTER"; },
    SETTING_REGISTER_DEVICE: function (uuid) { return "SETTING_REGISTER_DEVICE_".concat(uuid); },
    SETTING_ARTICLE: function () { return 'SETTING_ARTICLE'; },
    SETTING_COUPON_BUTTON: function () { return 'SETTING_COUPON_BUTTON'; },
    SETTING_FAQ_MENU: function (faqMenuId) { return "SETTING_FAQ_MENU_".concat(faqMenuId); },
    // TTV 및 긴급점검
    EMERGENCY: function () { return 'EMERGENCY'; },
    EMERGENCY_BUTTON: function () { return 'EMERGENCY_BUTTON'; },
    // 팝업
    POPUP: function () { return 'POPUP'; },
    NOTICE_POPUP: function () { return 'NOTICE_POPUP'; },
    POPUP_BUTTON: function (buttonIndex) { return "POPUP_BUTTON_".concat(buttonIndex); },
    NOTICE_POPUP_BUTTON: function (buttonIndex) { return "NOTICE_POPUP_BUTTON".concat(buttonIndex); },
    // SUBBOARD:
    SUB_BOARD_CONTENT: function () { return 'SUB_BOARD_CONTENT'; },
    SUB_BOARD_CONTENT_OPTION_ITEM: function () { return "SUB_BOARD_OPTION_MENU_ITEM"; },
    SUB_BOARD_OPTION_MENU: function (itemName) { return (itemName ? "SUB_BOARD_OPTION_MENU_ITEM".concat(itemName, " ") : 'SUB_BOARD_OPTION_MENU'); },
    TV_GRID: function () { return 'TV_GRID'; },
};
